import { useState } from 'react';
import PropTypes from 'prop-types';
import { PopoutMenu, RadioButton, Button, Icon } from '@bwoty-web/ui-kit';
import { UI_SORT_DESCENDING } from '@bwoty-web/ui-kit/icons';
import { useIsMobile } from '@bwoty-web/ui-kit/hooks';
import './sortPanel.scss';

const SortPanel = ({ sortOrder, setSortOrder, sortOrders, labels }) => {
  const [showSortPanel, setShowSortPanel] = useState(false);
  const isMobile = useIsMobile();
  const closeSortPanel = () => setShowSortPanel(false);

  const changeSortOrder = (event) => {
    setSortOrder(event.target.value);
    if (!isMobile) {
      closeSortPanel();
    }
  };

  const sortOrderOptions = sortOrders?.map((order) => ({
    id: order.sortOrder,
    title: order.label,
  }));

  const sortValues = sortOrderOptions.map((option) => ({
    id: option.id,
    title: (
      <RadioButton
        key={option.id}
        className="po-list-sort-order-option"
        name="sortOrder"
        value={option.id}
        checked={sortOrder === option.id}
        onChange={changeSortOrder}
        uniqueId={option.id}
      >
        {option.title}
      </RadioButton>
    ),
  }));

  return (
    <>
      <div className="po-list-sort-container">
        <Button
          variant="secondary-dark"
          className="po-list-sort-button"
          iconBefore={<Icon path={UI_SORT_DESCENDING} alt="" size="xs" />}
          onClick={() => setShowSortPanel(!showSortPanel)}
        >
          {labels?.sortTitle}
        </Button>
        <div className='po-list-sort-wrapper'>
          <PopoutMenu
            defaultHeight={40}
            onClose={closeSortPanel}
            title={labels?.sortTitle}
            show={showSortPanel}
            menuItems={sortValues}
          />
        </div>
      </div>
    </>
  );
};

SortPanel.propTypes = {
  sortOrder: PropTypes.string.isRequired,
  sortOrders: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setSortOrder: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    sortTitle: PropTypes.string.isRequired,
  }).isRequired,
};

export default SortPanel;